/**
 * Handles swatch clicks on product cards, updating the main image directly (no preloading).
 * Uses event delegation attached to #ProductGridContainer for the main collection
 * and separate delegated listeners for other .product-grid elements (e.g., featured sections).
 */
document.addEventListener('DOMContentLoaded', function() {

  // --- Reusable Core Swatch Handling Logic ---
  function handleSwatchClick(swatchElement) {
    const productCard = swatchElement.closest('.product-card-wrapper');
    if (!productCard) return;

    let variantImage = swatchElement.dataset.variantImage || swatchElement.dataset.sizeVariantImage;
    const productMedia = productCard.querySelector('.card__media');
    const productImage = productMedia ? productMedia.querySelector('img') : null;

    if (!productMedia || !productImage || !variantImage) return;

    if (variantImage.startsWith('//')) {
      variantImage = 'https:' + variantImage;
    } else if (!variantImage.startsWith('http')) {
      variantImage = 'https:' + variantImage;
    }

    // activate swatch
    productCard.querySelectorAll('.card-variant').forEach(btn => btn.classList.remove('active'));
    swatchElement.classList.add('active');

    // update color name
    const variantColorNameElement = productCard.querySelector('.variant-color-name');
    if (variantColorNameElement) {
      variantColorNameElement.textContent = swatchElement.dataset.variantName || '';
    }

    // update primary image only — the secondary (hover) image stays as the
    // server-rendered product media[1] (or media[2] if skip_video_hover_image is on)
    try {
      const baseUrl = new URL(variantImage);
      const cacheBust = Date.now();

      // Build a proper srcset so the browser never has to massively downscale
      // a high-res master image (which causes moiré on patterned fabrics/camo).
      const widths = [360, 533, 720, 940, 1066];
      productImage.srcset = widths.map(w => {
        const u = new URL(baseUrl.toString());
        u.searchParams.set('width', w);
        u.searchParams.set('t', cacheBust);
        return `${u.toString()} ${w}w`;
      }).join(', ');

      const srcUrl = new URL(baseUrl.toString());
      srcUrl.searchParams.set('width', 533);
      srcUrl.searchParams.set('t', cacheBust);
      productImage.src = srcUrl.toString();
    } catch (e) {
      console.error('Invalid variant image URL:', variantImage, e);
    }
  }

  // --- Set up Listeners ---

  // 1. Main collection page
  const collectionContainer = document.querySelector('#ProductGridContainer');
  if (collectionContainer) {
    collectionContainer.addEventListener('click', function(event) {
      const swatch = event.target.closest('.card-variant');
      if (swatch && swatch.closest('.product-grid')) {
        handleSwatchClick(swatch);
      }
    });
  }

  // 2. Other .product-grid sections
  const otherGrids = document.querySelectorAll('.product-grid');
  otherGrids.forEach(grid => {
    if (!collectionContainer || !collectionContainer.contains(grid)) {
      grid.addEventListener('click', function(event) {
        const swatch = event.target.closest('.card-variant');
        if (swatch) handleSwatchClick(swatch);
      });
    }
  });

  // --- Auto‑select the first variant on load (even if sold out) ---
  document.querySelectorAll('.product-card-wrapper').forEach(productCard => {
    const firstSwatch = productCard.querySelector('.card-variant');
    if (firstSwatch) handleSwatchClick(firstSwatch);
  });

  // --- Hover video play/pause ---
  document.querySelectorAll('.product-card-wrapper').forEach(productCard => {
    const video = productCard.querySelector('.card__media .hover-video');
    if (!video) return;

    const cardInner = productCard.querySelector('.card__inner');
    if (!cardInner) return;

    cardInner.addEventListener('mouseenter', () => {
      video.play().catch(() => {});
    });
    cardInner.addEventListener('mouseleave', () => {
      video.pause();
      video.currentTime = 0;
    });
  });

}); // End DOMContentLoaded
